/* Importing the PropTypes module from the prop-types package. */
import PropTypes from 'prop-types';

/* Importing the components from the Material UI library. */
import { Grid, Stack, TextField, } from '@mui/material';

PatientSectionRemarks.propTypes = {
  pagePatient: PropTypes.object,
};

/* Exporting the PatientSectionRemarks function. */
export default function PatientSectionRemarks(props) {
  /* Destructuring the props object and assigning the isEdit property to a variable of the same name. */
  const { pagePatient } = props;

  return (
    <form autoComplete="off">
      <Grid container>
        <Grid item xs={12}>
          <Stack spacing={3}>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
              <TextField
                fullWidth
                label="Remarks"
                rows={5}
                multiline
                value={pagePatient['patient-remarks']}
                style={{ border: 'none' }}
                variant="standard"
                InputProps={{ readOnly: true }}
              />
            </Stack>
          </Stack>
        </Grid>
      </Grid>
    </form>
  );
}
